module.exports = __webpack_public_path__ + "files/5bd655b659781c24cf2848b8f58dd006.png";